import { render, staticRenderFns } from "./activeExchangeRecordLists.vue?vue&type=template&id=15c0e93c&"
import script from "./activeExchangeRecordLists.vue?vue&type=script&lang=js&"
export * from "./activeExchangeRecordLists.vue?vue&type=script&lang=js&"
import style0 from "./activeExchangeRecordLists.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports